module.exports = __webpack_public_path__ + "static/media/like.eccb863c.svg";